import PropTypes from 'prop-types';
import React from 'react';

export class MessageDisplayBar extends React.Component {
  constructor(props) {
    super(props);
    this.dismissLink = null;
  }

  componentDidMount() {
    this.dismissLink.focus();
  }

  componentDidUpdate() {
    this.dismissLink.focus();
  }

  mapDismissRef = (element) => {
    this.dismissLink = element;
  }

  // change this.props.message to parse for links and apply link functions to onClick
  render() {
    return (
      <div className={ this.props.alertClass }>
        <span className="sr-only" tabIndex="-1" id="dismissLinkLabel">{this.props.dismissMessageSRLabel}</span>
        <a className="btn-close"
          aria-labelledby="alertText dismissLinkLabel"
          onClick={this.props.onClose}
          ref={this.mapDismissRef}
          id="dismissLink"
          tabIndex="0"
          type="button"
        ></a>
        <div id="alertText" tabIndex="-1">
          <span className={ this.props.glyphiconClass }></span>
          &nbsp;
          <span>{this.props.message}</span>
        </div>
      </div>
    );
  }
}

MessageDisplayBar.propTypes = {
  message: PropTypes.object.isRequired, // array of items to stuff into the message. ['Hi',<div>html</div>,"newrow"]
  onClose: PropTypes.func.isRequired,
  alertClass: PropTypes.string.isRequired,
  glyphiconClass: PropTypes.string.isRequired,
  dismissMessageSRLabel: PropTypes.string.isRequired,
};
